import React from 'react'
import styled, { keyframes } from 'styled-components'
import useSubgraphs from '../../hooks/useSubgraphs'
import Network from '../general/Network'

const Subgraphs: React.FC = () => {
  const data = useSubgraphs()

  if (data.isLoading) return <LoaderBar />

  return (
    <TableWrap>
      <Table>
        <thead>
          <tr>
            <Th>Network</Th>
            <Th>Subgraph</Th>
            <Th>Synced</Th>
            <Th>Fatal error</Th>
            <Th>Non-fatal errors</Th>
          </tr>
        </thead>
        <tbody>
          {data?.data?.map((item, index) => (
            <tr key={index}>
              <Td><Network network={item.chainId} /></Td>
              <Td><Mono>{item.subgraph}</Mono></Td>
              <Td><StatusDot ok={item.synced} title={item.synced ? 'Synced' : 'Not synced'} /></Td>
              <Td>
                {item.fatalError
                  ? <ErrorText>{String(item.fatalError)}</ErrorText>
                  : <Muted>—</Muted>}
              </Td>
              <Td>
                {item.nonFatalErrors?.length > 0
                  ? item.nonFatalErrors.map((err: any, i: number) => (
                      <ErrorText key={i}>{String(err)}</ErrorText>
                    ))
                  : <Muted>—</Muted>}
              </Td>
            </tr>
          ))}
        </tbody>
      </Table>
    </TableWrap>
  )
}

export default Subgraphs

// ─── Styles ──────────────────────────────────────────────────────────────────

const shimmer = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`

const LoaderBar = styled.div`
  height: 2px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 2px;
  overflow: hidden;
  position: relative;

  &::after {
    content: '';
    display: block;
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, transparent, rgba(111, 92, 230, 0.5), transparent);
    animation: ${shimmer} 1.4s ease infinite;
  }
`

const TableWrap = styled.div`
  overflow-x: auto;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 8px;
`

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
`

const Th = styled.th`
  padding: 10px 12px;
  text-align: left;
  color: #a1a1a1;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
`

const Td = styled.td`
  padding: 10px 12px;
  color: #a0a0a0;
  font-size: 13px;
  vertical-align: middle;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  tr:last-child & { border-bottom: none; }
`

const Mono = styled.span`
  font-family: 'SF Mono', 'Fira Code', monospace;
  font-size: 11px;
  color: #777;
  word-break: break-all;
`

const StatusDot = styled.span<{ ok: boolean }>`
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: ${({ ok }) => ok ? '#33C2B0' : '#ff4444'};
`

const ErrorText = styled.p`
  color: #ff4444;
  font-size: 11px;
  margin: 2px 0;
`

const Muted = styled.span`color: #777;`
